const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

/**
 * Data de hoje no relógio do aparelho, no formato `YYYY-MM-DD` das datas da
 * busca. É o mesmo "hoje" que o calendário usa para desabilitar dias passados,
 * então o usuário nunca escolhe uma data que a SERP depois chame de passada.
 */
export const getToday = (now: Date = new Date()): string => {
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");

  return `${now.getFullYear()}-${month}-${day}`;
};

const isPastDate = (date: string, today: string) =>
  ISO_DATE.test(date) && date < today;

/** Datas de ida que ainda não passaram. Valores fora do formato são mantidos: quem decide é a API. */
export const filterPastDepartureDates = (
  departureDates: readonly string[] | null | undefined,
  today: string = getToday(),
): string[] =>
  (departureDates ?? []).filter((date) => !isPastDate(date, today));

/**
 * Verdadeiro quando há datas de ida e TODAS já passaram. Se sobra ao menos uma
 * data futura a busca segue só com ela, em vez de bloquear tudo.
 */
export const hasOnlyPastDepartureDates = (
  departureDates: readonly string[] | null | undefined,
  today: string = getToday(),
): boolean =>
  (departureDates?.length ?? 0) > 0 &&
  filterPastDepartureDates(departureDates, today).length === 0;

/** `2026-10-26` → `26/10/2026`. Devolve o valor original se não for ISO. */
export const formatIsoDateToBr = (date: string): string => {
  if (!ISO_DATE.test(date)) {
    return date;
  }

  const [year, month, day] = date.split("-");

  return `${day}/${month}/${year}`;
};
